/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Demo_Hello_DescriptionInputs */

const en_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a mini window demo.`)
};

const ar_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه نافذة تجريبية صغيرة.`)
};

const bn_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এটি একটি মিনি উইন্ডো ডেমো।`)
};

const de_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ist eine Mini-Fensterdemo.`)
};

const es_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es una demostración de mini ventana.`)
};

const fr_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceci est une mini-démo de fenêtre.`)
};

const pt_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é uma demonstração em mini janela.`)
};

const zh_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一个迷你窗口演示。`)
};

const tr_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu bir mini pencere demosudur.`)
};

const ru_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это демонстрация мини-окна.`)
};

const pl_draft_demo_hello_description = /** @type {(inputs: Draft_Demo_Hello_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To jest mini demo okna.`)
};

/**
* | output |
* | --- |
* | "This is a mini window demo." |
*
* @param {Draft_Demo_Hello_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const draft_demo_hello_description = /** @type {((inputs?: Draft_Demo_Hello_DescriptionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Demo_Hello_DescriptionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_draft_demo_hello_description(inputs)
	if (locale === "bn") return bn_draft_demo_hello_description(inputs)
	if (locale === "de") return de_draft_demo_hello_description(inputs)
	if (locale === "es") return es_draft_demo_hello_description(inputs)
	if (locale === "fr") return fr_draft_demo_hello_description(inputs)
	if (locale === "pt") return pt_draft_demo_hello_description(inputs)
	if (locale === "zh") return zh_draft_demo_hello_description(inputs)
	if (locale === "tr") return tr_draft_demo_hello_description(inputs)
	if (locale === "ru") return ru_draft_demo_hello_description(inputs)
	if (locale === "pl") return pl_draft_demo_hello_description(inputs)
	return en_draft_demo_hello_description(inputs)
});